<template>
  <div>
    <div class="fixed-right-sidebar">
      <div class="sidebar-main">
        <div @mouseover="sidebarTab(2)" @mouseout="sidebarTabOut" :class="['sidebar-item', 'sidebar-iphone', fixedTab == 2 ? 'activeHidden' : '']">
          <div :class="['item-bj', fixedTab == 2 ? ['bj-hover', 'bj-hover-call'] : '']">
            <div :class="['item-box3', 'item-box', fixedTab == 2 ? 'activeH1' : '']">
              <div class="hover-item-i">
                <div class="item-b">
                  <div class="call-num">
                    <p><img src="./img/icon_call.png" />电话咨询</p>
                    <h3>400-688-2850</h3>
                  </div>

                  <div class="work-time">
                    <h3>工作时间:</h3>
                    <p>周一至周五（8:30-18:00）<br />节假日除外</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @mouseover="sidebarTab(3)" @mouseout="sidebarTabOut" :class="['sidebar-item', 'sidebar-wechat', fixedTab == 3 ? 'activeHidden' : '']">
          <div :class="['item-bj', fixedTab == 3 ? ['bj-hover', 'bj-hover-wechat'] : '']"></div>
          <div :class="['item-box1', 'item-box', fixedTab == 3 ? 'activeH1' : '']">
            <div class="hover-item">
              <img :src="require('./img/focusCode@2x2.jpg')" />
              <p>关注InZ应龙官方微信 实时查看订单最新动态</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 返回顶部 -->
      <div v-show="backTopStatus" class="sidebar-item sidebar-top">
        <!-- fa fa-caret-up sidebar-up -->
        <div @click="backTop" class="up-img"></div>
      </div>

      <div id="web-chat-page">
        <div class="close-btn" @click="closeChat()">&times;</div>
        <iframe id="web-chat-iframe" height="100%" width="100%" frameborder="0" src=""> </iframe>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import { thirdParty, ERR_OK, ERR_LOGINAGAIN, storageVTime } from 'api/config'
import { getBanner, IMGClick, cmsBannerNew } from 'api/banner'
import * as util from 'assets/js/util'
import { setTimeout, clearTimeout } from 'timers'
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      backTopStatus: false,
      scrollTop: 0,
      fixedTab: -1,
      tips: false,
      bannerImgData: { goUrl: '', targetPicture: '', pictureUrl: '' },
      bannerType: 2, //侧边栏图片2
      userInfo: null,
      img_ult: require('./img/Side_icon_consult.png'),
      img_call: require('./img/Side_icon_call.png'),
      img_wechat: require('./img/Side_icon_wechat.png')
    }
  },
  created() {},
  computed: {
    ...mapGetters(['bannerState']),
    testUrl() {
      return process.env.TEST_TYPE_URL
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 侧边栏
    sidebarTab(index) {
      // console.log(index)
      this.fixedTab = index
    },
    // 鼠标离开
    sidebarTabOut() {
      this.fixedTab = -1
    },
    scrollToTop() {
      const that = this
      // window.pageXOffset ||
      that.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(that.scrollTop,'chufa?')
      if (that.scrollTop > 500) {
        that.backTopStatus = true
      } else {
        that.backTopStatus = false
      }
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    ...mapMutations({
      SetBannerState: 'SET_BANNERSTATE'
    })
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '~assets/scss/compile';
@import './fixedNew';
</style>
<style>
.embed-icon-default {
  border-radius: 0 !important;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05) !important;
}
@media (-webkit-device-pixel-ratio: 1.5) {
  .embed-icon {
    zoom: 66% !important;
  }
}
@media (-webkit-device-pixel-ratio: 1.25) {
  .embed-icon {
    zoom: 80% !important;
  }
}
.embed-icon-default:hover {
  position: relative;
  width: 100%;
  height: 100%;
  white-space: pre;
}
.embed-icon-default:hover::before {
  content: '点击' '\A''咨询';
  white-space: pre;
  position: absolute;
  font-size: 12px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  color: #fff !important;
  background-color: #ea5219 !important;
  transition: all 0.3s;
  border-color: #ea5219 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.embed-icon {
  z-index: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/fixed/fixedNew.vue